import styled from "styled-components";
import { Button, Card } from "react-bootstrap";

export const WitLabel = styled.label`
  display: block;
  width: 100%;
  padding: 0;
  margin: 30px 0 20px 0;
  font-size: 21px;
  line-height: inherit;
  color: #3a3f51;
  border: 0;
  border-bottom: 1px solid #e5e5e5;
`;

export const StyledCard = styled(Card)`
  margin: 22px;
  .nav-tabs .errorTab .nav-link.active {
    background-color: #fbb4ac;
    border: 1px solid #fb6d81;
  }
`;

export const ErrorField = styled.div`
  width: 100%;
  margin-top: 10px;
  background-color: #f5abba;
  border-radius: 5px;
  padding: 2px 5px;
  color: #6e0218;
`;

export const StyledBackButton = styled(Button)`
  background-color: #edeff2 !important;
  color: #212529 !important;
`;

export const DateRangePickerWrapper = styled.div<{ hasError: boolean }>`
  .DateRangePicker {
    border-radius: 5px;
  }

  .DateRangePickerInput {
    border-radius: 5px;
    border-color: hsl(0, 0%, 80%);
    width: 240px;
    padding: 1px;
  }

  .DateInput {
    border-radius: 5px;
  }

  .DateInput_input {
    font-size: 12px;
    font-weight: normal;
  }

  .DateRangePickerInput_clearDates_svg {
    width: auto;
  }
`;
